// extracted by mini-css-extract-plugin
module.exports = {"Slider":"Checkbox_Slider__1H8eq","SliderChecked":"Checkbox_SliderChecked__1NxNa","SliderRound":"Checkbox_SliderRound__1HUEK","SliderLabel":"Checkbox_SliderLabel__24laV"};